<template>
  <v-data-table :items="visibleItems" :loading="loading" hide-actions>
    <template v-slot:headers>
      <tr class="headerRow grey lighten-3">
        <th>クリエイティブ名</th>
        <th>ステータス</th>
        <th>配信設定適用期間</th>
      </tr>
    </template>
    <template v-slot:items="{ item }">
      <tr class="itemRow">
        <td>
          <span>{{ item.name }}</span>
        </td>
        <td>
          <AppStatus :value="item.status" readonly with-icon />
        </td>
        <td>
          <AppPeriod
            :start="item.startTime"
            :end="item.endTime"
            empty-text="指定なし"
          />
        </td>
      </tr>
    </template>
    <template slot="no-data">
      <td colspan="3">
        <div class="text-xs-center">
          <slot name="empty">クリエイティブが設定されていません</slot>
        </div>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { CreativeRepository } from '@/models/Creative'

export default {
  name: 'CampaignModalPageConfirmCreativeTable',
  props: {
    creatives: {
      type: Array,
      required: true,
    },
    activeOnly: Boolean,
  },
  data() {
    return {
      creativesPool: [],
      loading: false,
    }
  },
  computed: {
    items() {
      return this.creativesPool.length > 0
        ? this.creatives
            .map(({ id }) => {
              const creative = this.findCreative(id)
              const { name, status } = creative
              return {
                id,
                name,
                status,
              }
            })
            .flat()
        : []
    },
    visibleItems() {
      return this.items.filter(
        item => !this.activeOnly || item.status === 'active',
      )
    },
  },
  watch: {
    creatives() {
      this.fetchCreatives()
    },
  },
  created() {
    this.fetchCreatives()
  },
  methods: {
    async fetchCreatives() {
      try {
        this.loading = true
        this.creativesPool = []
        this.creativesPool = await CreativeRepository.findByIdsWithFolderInfo(
          this.creatives.flat(),
        )
      } catch (e) {
        console.error(e)
        throw new Error('クリエイティブデータが取得できません。')
      } finally {
        this.loading = false
      }
    },
    findCreative(id) {
      return this.creativesPool.find(c => c.id === id)
    },
  },
}
</script>

<style scoped lang="scss">
.headerRow {
  height: 24px;

  th {
    padding: 0 8px !important;
    text-align: left;
  }
}

.itemRow {
  td {
    padding: 0 8px !important;
  }
}
</style>
